import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { Divider } from 'antd';
import Icon from '@ant-design/icons';
import { formatPercentage } from 'utils/number';
import InfoSvg from 'global/Securities/components/Icons/InfoSvg';
import { formatBondCurrency } from 'features/securities/withdrawal/utils';
import { useBondPreviewStore } from '../../../stores/useBondPreview';
import { BondInfoType } from '../../../constants';
import { Section } from '../styled';
import { useBondInfoModal } from '../../../stores/useBondInfoModal';

export default function ContentBuy() {
  const field = useBondPreviewStore((s) => s.buy);
  const openInfoModal = useBondInfoModal((s) => s.openInfoModal);

  return (
    <>
      <Section>
        <Flex justify="space-between" align="center" height="20px">
          <Text>Unit Pembelian</Text>
          <Text>{field?.unit}</Text>
        </Flex>
        <Flex justify="space-between" align="center" height="20px">
          <Text>Harga Beli (%)</Text>
          <Text>{formatPercentage(field?.price_rate, true, '0,0.00')}</Text>
        </Flex>
      </Section>
      <Divider
        css={`
          margin: 0px;
          margin-bottom: 12px;
          border-color: #dadada;
        `}
      />
      <Section>
        <Flex justify="space-between" align="center" height="20px">
          <Text>Nilai Pembelian</Text>
          <Text>{formatBondCurrency(field?.buy_price_amount)}</Text>
        </Flex>
        <Flex justify="space-between" align="center" height="20px">
          <Flex align="center" style={{ gap: 2 }}>
            <Flex align="center">
              <span>Kupon Penjual</span>
              <Icon
                component={InfoSvg}
                style={{ color: '#969696' }}
                onClick={() =>
                  openInfoModal(BondInfoType.ACCRUED_INTEREST_SELLER)
                }
              />
            </Flex>
          </Flex>
          <Text>
            {formatBondCurrency(field?.accrued_interest, 'exceptZero')}
          </Text>
        </Flex>
        <Flex justify="space-between" align="center" height="20px">
          <Text>Bea Meterai</Text>
          <Text>
            {formatBondCurrency(field?.fee?.stamp_duty, 'exceptZero')}
          </Text>
        </Flex>
        <Flex justify="space-between" align="center" height="20px">
          <Text family="bold">Total Pembayaran</Text>
          <Text family="bold">{formatBondCurrency(field?.total_amount)}</Text>
        </Flex>
      </Section>
    </>
  );
}
